import React, { useContext } from "react";

import {
  Form,
  Link,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import img from "../../assets/images/login.jpg";
import { AuthContext } from "../../Context/AuthProvider/AuthProvider";
const Login = () => {
  const { userLogin } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";
  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    const email = form.email.value;
    const password = form.password.value;
    userLogin(email, password)
      .then((result) => {
        const user = result.user;
        console.log(user);
        form.reset();
        navigate(from, { replace: true });
      })
      .catch((e) => {
        console.error(e);
      });
  };
  return (
    <div className="hero my-20 min-h-screen bg-base-200">
      <div className="hero-content gap-10 grid md:grid-cols-2 flex-col lg:flex-row">
        <div className="text-center lg:text-left">
          <img className="w-3/4 " src={img} alt="" />
        </div>
        <Form
          onSubmit={handleSubmit}
          className="card  flex-shrink-0 w-full max-w-sm shadow-2xl bg-base-100"
        >
          <div className="card-body">
            <h1 className="text-3xl font-bold">Login now!</h1>
            <div className="form-control">
              <label className="label">
                <span className="label-text">Email</span>
              </label>
              <input
                type="email"
                placeholder="email"
                name="email"
                className="input input-bordered"
                required
              />
            </div>
            <div className="form-control">
              <label className="label">
                <span className="label-text">Password</span>
              </label>
              <input
                type="password"
                name="password"
                placeholder="password"
                className="input input-bordered"
                required
              />
              <label className="label">
                <a href="#" className="label-text-alt link link-hover">
                  Forgot password?
                </a>
              </label>
            </div>
            <div className="text-center">
              <div className="form-control mt-6">
                <button className="btn btn-primary">Login</button>
              </div>
              {/* <p className="">or</p>
              <div className="form-control mt-6">
                <button className="btn btn-primary">Login with Google</button>
              </div> */}
            </div>
            <p>
              New to Spooky Journal?{" "}
              <Link to="/signup">
                <span className="text-orange-700 px-5 font-bold">Sign Up</span>
              </Link>{" "}
            </p>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default Login;
